import Box from "@/components/Box";
import { InternalTextLink } from "@/components/Links";
import { CMP_SIGNIN_URL } from "@/core/urls";
import Asterisk from "@/tpo/Asterisk";
import ControlledFormField from "@/tpo/ControlledFormField";
import ControlledRadioGroup from "@/tpo/ControlledRadioGroup";
import DateInput from "@/tpo/DateInput";
import FloatingLabelInput from "@/tpo/FloatingLabelInput";
import FormControl from "@/tpo/FormControl";
import FloatingLabelPasswordInput from "@/tpo/PasswordInput";
import ShippingCountrySelect from "@/tpo/ShippingCountrySelect";
import Stack from "@/tpo/Stack";

export default function YourDetails({
  readOnlyFields,
  showLoginLink,
  showPasswordFields,
  showEmailHelpText
}) {
  return (
    <Stack bg="white" pt={40} pb={80} px={[20, 20, 80]} gap={40} borderRadius={5}>
      <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]} lineHeight="46px">
        Your details
        <Asterisk />
      </Box>
      <Stack fontFamily="gilroyMedium" gap={20}>
        <ControlledFormField
          name="firstName"
          label="First name"
          Component={FloatingLabelInput}
          editable={!readOnlyFields.includes("firstName")}
        />
        <ControlledFormField
          name="lastName"
          label="Last name"
          Component={FloatingLabelInput}
          editable={!readOnlyFields.includes("lastName")}
        />
        {showEmailHelpText && (
          <Box fontFamily="inherit" fontSize={16} lineHeight="24px">
            Please enter your student email address if available
          </Box>
        )}
        <ControlledFormField
          name="email"
          label="Email address"
          Component={FloatingLabelInput}
          editable={!readOnlyFields.includes("email")}
        />
        <ControlledFormField
          name="phoneNumber"
          label="Contact number"
          Component={FloatingLabelInput}
        />
        <ControlledFormField
          name="businessLocationCity"
          label="Location City"
          Component={FloatingLabelInput}
        />
        <ControlledFormField
          name="businessCountry"
          placeholder="Country"
          Component={ShippingCountrySelect}
          valueField="id"
        />
      </Stack>
      {showPasswordFields && (
        <FormControl
          as="fieldset"
          label={
            <Box fontFamily="gilroyBold" fontSize={[18]}>
              Password
              <Asterisk />
            </Box>
          }
          fields={
            <>
              <ControlledFormField
                name="password"
                label="Password"
                Component={FloatingLabelPasswordInput}
              />
              <ControlledFormField
                name="confirmPassword"
                label="Confirm Password"
                Component={FloatingLabelPasswordInput}
              />
            </>
          }
        />
      )}
      {showLoginLink && (
        <Box fontFamily="gilroyMedium" fontSize={16}>
          Already a user? Click <InternalTextLink href={CMP_SIGNIN_URL}>here</InternalTextLink>{" "}
          login
        </Box>
      )}
      <ControlledFormField
        name="dateOfBirth"
        Component={DateInput}
        getDay={dateStr => (dateStr ? dateStr.split("-")[2] : "")}
        getMonth={dateStr => (dateStr ? dateStr.split("-")[1] : "")}
        getYear={dateStr => (dateStr ? dateStr.split("-")[0] : "")}
        constructDate={({ day, month, year }) => {
          return `${year}-${month}-${day}`;
        }}
        label="Date of birth"
        labelProps={{
          fontFamily: "gilroyBold",
          fontSize: 18,
          mb: 20
        }}
        disabled={readOnlyFields.includes("dateOfBirth")}
      />
      <ControlledRadioGroup
        Container={Stack}
        containerProps={{
          gap: 20
        }}
        name="gender"
        label="Gender"
        labelProps={{
          fontFamily: "gilroyBold",
          fontSize: 18,
          mb: 20
        }}
        values={[
          {
            label: "Male",
            value: "Male"
          },
          {
            label: "Female",
            value: "Female"
          }
        ]}
        disabled={readOnlyFields.includes("gender")}
      />
    </Stack>
  );
}
